<div class="header">
  <h5 style="font-size: 20px; margin: 0">Request for Proposal (RFP)</h5>
  <p
    class="!mt-[10px] bg-[#f4f4f4] !text-[ 0.625rem] rounded-[0.625rem] flex items-center w-[auto] h-[1.7rem] border pl-[1rem]"
    style="padding: 0 0.35rem 0 0.35rem; margin-left: 0.8rem"
  >
    Consultancy Services
  </p>
  <img
    src="assets/icons/cross-icon.svg"
    alt="cross icon"
    class="crossicon h-[15px] w-[15px]"
    (click)="closeDialog()"
  />
</div>

<div class="p-0 !py-0 relative" id="InitiateRfp">
  <div class="flex justify-end items-center mx-[40px] pt-[10px]">
    <div class="flex items-center">
      <button
        *ngIf="isRFPorRFQ === 'RFP'"
        (click)="evaluation(1)"
        type="button"
        class="print-button mr-[0.5rem]"
      >
        Technical Evaluation
      </button>
      <button
        *ngIf="isRFPorRFQ === 'RFP'"
        (click)="evaluation(2)"
        type="button"
        class="print-button mr-[0.5rem]"
      >
        Commercial Evaluation
      </button>
      <button (click)="rfpPrint()" class="print-button mr-[0.5rem]">
        Print
      </button>
      <img
        src="assets/images/logo.png"
        alt="logo"
        class="h-[65px] w-[65px] rounded-[7px]"
      />
    </div>
  </div>
  <div
    class="-fluid flex justify-center h-auto !pt-0 !m-[0px] !mt-[0px] !mb-[0px] !pb-[0px]"
  >
    <div class="w-full !mb-[20px]">
      <div class="!p-[0px] !pb-0 !bg-[#ffffff] !pt-[0px]">
        <!-- project Brief  -->
        <div
          class="h-[55px] flex justify-start items-center pl-[60px] mb-[18px] bg-[#F1F3F5]"
        >
          <h5 class="!m-0">Project Brief</h5>
        </div>
        <div class="!px-[60px]">
          <app-project-brief></app-project-brief>
        </div>
      </div>
    </div>
  </div>
  <!-- Work Packages -->
  <div>
    <h5
      class="h-[55px] flex justify-start items-center mt-[10px] pl-[60px] mb-[18px] bg-[#F1F3F5]"
    >
      Selected Work Packages
    </h5>
    <div
      class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-2 !mb-[30px]"
    >
      <div class="p-5 !py-0">
        <div class="rounded p-10 !py-0" *ngIf="selectedWp.length > 0">
          <div class="!w-[500px]" *ngFor="let wp of selectedWp">
            <p>{{ wp.name }}</p>
          </div>
        </div>
        <div class="rounded p-10 !py-0" *ngIf="selectedWp.length === 0">
          <div class="!w-[500px]">
            <p>No Work Packages Selected</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Request For Proposal ( RFP ) -->
  <!--Consultancy Services  -->
  <div
    *ngIf="tenderType && tenderType !== 'construction works'"
    class="!pl-[60px]"
  >
    <div>
      <h5
        class="h-[55px] flex justify-start items-center mt-[10px] pl-[60px] !text-[20px] mb-[18px] bg-[#F3F3F3]"
      >
        Request for Proposal (RFP)
      </h5>
      <h5 class="!pt-[3px] !text-[1.125rem]">Consultancy Services</h5>
      <label class="!pt-[3px] mb-[1rem]">Project Management</label>
      <div
        class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4 mb-[1rem]"
      >
        <div class="pl-[60px]">
          <p
            class="text-justify pr-[3.5rem]"
            [innerHTML]="getSanitizedHtml(tendererResponse?.project_management)"
          ></p>
        </div>
      </div>
    </div>

    <!-- Design Services  -->
    <div>
      <label class="!pt-[3px] mb-[1rem]"> Design Services </label>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
        <div class="pl-[60px]">
          <p
            class="text-justify pr-[3.5rem] mb-[1rem]"
            [innerHTML]="getSanitizedHtml(tendererResponse?.design_services)"
          ></p>
        </div>
      </div>
    </div>
    <!--  Cost Consultancy/Quantity Surveying: -->
    <div>
      <label class="!pt-[3px] mb-[1rem]">
        Cost Consultancy/Quantity Surveying:
      </label>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
        <div class="pl-[60px]">
          <p
            class="text-justify pr-[3.5rem] mb-[1rem]"
            [innerHTML]="getSanitizedHtml(tendererResponse?.cost_consultancy)"
          ></p>
        </div>
      </div>
    </div>
    <!-- Contract Administration -->
    <div>
      <label class="!pt-[3px] mb-[1rem]"> Contract Administration </label>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
        <div class="pl-[60px] mb-[1rem]">
          <p
            class="text-justify pr-[3.5rem]"
            [innerHTML]="
              getSanitizedHtml(tendererResponse?.contract_administration)
            "
          ></p>
        </div>
      </div>
    </div>
    <!-- Risk Management and Feasibility Studies: -->
    <div>
      <label class="!pt-[3px] mb-[1rem]">
        Risk Management and Feasibility Studies:
      </label>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
        <div class="pl-[60px] mb-[1rem]">
          <p
            class="text-justify pr-[3.5rem]"
            [innerHTML]="getSanitizedHtml(tendererResponse?.risk_management)"
          ></p>
        </div>
      </div>
    </div>
    <!-- Ensure Sustainability and Compliance -->
    <div>
      <label class="!pt-[3px] mb-[1rem]">
        Ensure Sustainability and Compliance
      </label>
      <div>
        <div class="pl-[60px]">
          <p
            class="text-justify"
            [innerHTML]="
              getSanitizedHtml(tendererResponse?.sustainability_compliance)
            "
          ></p>
        </div>
      </div>
    </div>
    <!-- Final Inspection, Sustainability, and Compliance -->
    <div>
      <label class="!pt-[3px] mb-[1rem]">
        Final Inspection, Sustainability, and Compliance
      </label>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
        <div class="pl-[60px] mb-[1rem]">
          <p
            class="text-justify pr-[3.5rem]"
            [innerHTML]="
              getSanitizedHtml(
                tendererResponse?.final_sustainability_compliance
              )
            "
          ></p>
        </div>
      </div>
    </div>
  </div>

  <!-- Construction Work -->
  <div
    *ngIf="tenderType && tenderType === 'construction works'"
    class="!pl-[60px]"
  >
    <h5 class="!pt-[3px] !text-[1.125rem]">Construction Work</h5>

    <div class="my-[1rem]">
      <label class="">Site Preparation</label>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
        <div>
          <p
            class="text-justify"
            [innerHTML]="getSanitizedHtml(tendererResponse?.site_preparation)"
          ></p>
        </div>
      </div>
      <!-- Site Preparation Files-->
      <div class="items-center" *ngIf="sitePreparationAttachments?.length > 0">
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[0.9rem] leading-normal"
        >
          Attachments

          <!-- Download attachment -->
          <div class="flex flex-col space-y-2 pl-[2rem]">
            <a
              *ngFor="let attachment of sitePreparationAttachments"
              class="flex space-x-2"
              [ngClass]="{
                'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                  sitePreparationAttachments,
                'text-black font-roboto text-[14px] font-normal leading-normal':
                  sitePreparationAttachments
              }"
              #downloadTendererDocumentLink
              [href]="docUrl || '#'"
              (click)="
                downloadTendererDocument(
                  $event,
                  downloadTendererDocumentLink,
                  attachment?.id,
                  attachment?.path
                )
              "
            >
              <img
                [src]="getFileIcon(attachment)"
                alt="File Preview"
                class="object-cover w-5 h-5 cursor-pointer"
              />
              <span>{{ attachment?.name }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="my-[1rem]">
      <label>Structural and Civil Works</label>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
        <div>
          <p
            class="text-justify"
            [innerHTML]="
              getSanitizedHtml(tendererResponse?.structural_civil_works)
            "
          ></p>
        </div>
      </div>
      <!-- Site Preparation Files-->
      <div
        class="items-center"
        *ngIf="structuralCivilWorksAttachments?.length > 0"
      >
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[0.9rem] leading-normal"
        >
          Attachments

          <!-- Download attachment -->
          <div class="flex flex-col space-y-2 pl-[2rem]">
            <a
              *ngFor="let attachment of structuralCivilWorksAttachments"
              class="flex space-x-2"
              [ngClass]="{
                'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                  structuralCivilWorksAttachments,
                'text-black font-roboto text-[14px] font-normal leading-normal':
                  structuralCivilWorksAttachments
              }"
              #downloadTendererDocumentLink
              [href]="docUrl || '#'"
              (click)="
                downloadTendererDocument(
                  $event,
                  downloadTendererDocumentLink,
                  attachment?.id,
                  attachment?.path
                )
              "
            >
              <img
                [src]="getFileIcon(attachment)"
                alt="File Preview"
                class="object-cover w-5 h-5 cursor-pointer"
              />
              <span>{{ attachment?.name }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="my-[1rem]">
      <label>MEP Works</label>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
        <div>
          <p
            class="text-justify"
            [innerHTML]="getSanitizedHtml(tendererResponse?.mep_works)"
          ></p>
        </div>
      </div>
      <!-- Site Preparation Files-->
      <div class="items-center" *ngIf="mepWorksAttachments?.length > 0">
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[0.9rem] leading-normal"
        >
          Attachments

          <!-- Download attachment -->
          <div class="flex flex-col space-y-2 pl-[2rem]">
            <a
              *ngFor="let attachment of mepWorksAttachments"
              class="flex space-x-2"
              [ngClass]="{
                'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                  mepWorksAttachments,
                'text-black font-roboto text-[14px] font-normal leading-normal':
                  mepWorksAttachments
              }"
              #downloadTendererDocumentLink
              [href]="docUrl || '#'"
              (click)="
                downloadTendererDocument(
                  $event,
                  downloadTendererDocumentLink,
                  attachment?.id,
                  attachment?.path
                )
              "
            >
              <img
                [src]="getFileIcon(attachment)"
                alt="File Preview"
                class="object-cover w-5 h-5 cursor-pointer"
              />
              <span>{{ attachment?.name }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="my-[1rem]">
      <label>Finishing and Fit-Out</label>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
        <div>
          <p
            class="text-justify"
            [innerHTML]="getSanitizedHtml(tendererResponse?.finishing_fitout)"
          ></p>
        </div>
      </div>
      <!-- Site Preparation Files-->
      <div class="items-center" *ngIf="fitoutAttachments?.length > 0">
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[0.9rem] leading-normal"
        >
          Attachments

          <!-- Download attachment -->
          <div class="flex flex-col space-y-2 pl-[2rem]">
            <a
              *ngFor="let attachment of fitoutAttachments"
              class="flex space-x-2"
              [ngClass]="{
                'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                  fitoutAttachments,
                'text-black font-roboto text-[14px] font-normal leading-normal':
                  fitoutAttachments
              }"
              #downloadTendererDocumentLink
              [href]="docUrl || '#'"
              (click)="
                downloadTendererDocument(
                  $event,
                  downloadTendererDocumentLink,
                  attachment?.id,
                  attachment?.path
                )
              "
            >
              <img
                [src]="getFileIcon(attachment)"
                alt="File Preview"
                class="object-cover w-5 h-5 cursor-pointer"
              />
              <span>{{ attachment?.name }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="my-[1rem]">
      <label>Health & Safety Compliance</label>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
        <div>
          <p
            class="text-justify"
            [innerHTML]="
              getSanitizedHtml(tendererResponse?.health_safety_compliance)
            "
          ></p>
        </div>
      </div>
      <!-- Site Preparation Files-->
      <div class="items-center" *ngIf="healthSafetyAttachments?.length > 0">
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[0.9rem] leading-normal"
        >
          Attachments

          <!-- Download attachment -->
          <div class="flex flex-col space-y-2 pl-[2rem]">
            <a
              *ngFor="let attachment of healthSafetyAttachments"
              class="flex space-x-2"
              [ngClass]="{
                'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                  healthSafetyAttachments,
                'text-black font-roboto text-[14px] font-normal leading-normal':
                  healthSafetyAttachments
              }"
              #downloadTendererDocumentLink
              [href]="docUrl || '#'"
              (click)="
                downloadTendererDocument(
                  $event,
                  downloadTendererDocumentLink,
                  attachment?.id,
                  attachment?.path
                )
              "
            >
              <img
                [src]="getFileIcon(attachment)"
                alt="File Preview"
                class="object-cover w-5 h-5 cursor-pointer"
              />
              <span>{{ attachment?.name }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="my-[1rem]">
      <label>Post-Construction Activities</label>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
        <div>
          <p
            class="text-justify"
            [innerHTML]="
              getSanitizedHtml(tendererResponse?.post_construction_activities)
            "
          ></p>
        </div>
      </div>
      <!-- Site Preparation Files-->
      <div class="items-center" *ngIf="postConstructionAttachments?.length > 0">
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[0.9rem] leading-normal"
        >
          Attachments

          <!-- Download attachment -->
          <div class="flex flex-col space-y-2 pl-[2rem]">
            <a
              *ngFor="let attachment of postConstructionAttachments"
              class="flex space-x-2"
              [ngClass]="{
                'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                  postConstructionAttachments,
                'text-black font-roboto text-[14px] font-normal leading-normal':
                  postConstructionAttachments
              }"
              #downloadTendererDocumentLink
              [href]="docUrl || '#'"
              (click)="
                downloadTendererDocument(
                  $event,
                  downloadTendererDocumentLink,
                  attachment?.id,
                  attachment?.path
                )
              "
            >
              <img
                [src]="getFileIcon(attachment)"
                alt="File Preview"
                class="object-cover w-5 h-5 cursor-pointer"
              />
              <span>{{ attachment?.name }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--Required Documentation: -->
  <!-- Technical Submission: -->
  <div class="!pl-[60px]">
    <h5 class="!pt-[3px] !text-[1.125rem]">Required Documentation</h5>
    <!-- Technical Proposal -->
    <div>
      <label>Technical Submission</label>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
        <div>
          <p
            class="text-justify"
            [innerHTML]="getSanitizedHtml(tendererResponse?.technical_proposal)"
          ></p>
        </div>
      </div>
      <!-- Technical Proposal Files-->
      <div
        class="items-center"
        *ngIf="technicalProposalAttachments?.length > 0"
      >
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[0.9rem] leading-normal"
        >
          Attachments

          <!-- Download attachment -->
          <div class="flex flex-col space-y-2 pl-[2rem]">
            <a
              *ngFor="let attachment of technicalProposalAttachments"
              class="flex space-x-2"
              [ngClass]="{
                'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                  technicalProposalAttachments,
                'text-black font-roboto text-[14px] font-normal leading-normal':
                  technicalProposalAttachments
              }"
              #downloadTendererDocumentLink
              [href]="docUrl || '#'"
              (click)="
                downloadTendererDocument(
                  $event,
                  downloadTendererDocumentLink,
                  attachment?.id,
                  attachment?.path
                )
              "
            >
              <img
                [src]="getFileIcon(attachment)"
                alt="File Preview"
                class="object-cover w-5 h-5 cursor-pointer"
              />
              <span>{{ attachment?.name }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Project Programme -->
    <div class="my-[1rem]">
      <label>Project Programme</label>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
        <div>
          <p
            class="text-justify"
            [innerHTML]="getSanitizedHtml(tendererResponse?.project_programme)"
          ></p>
        </div>
      </div>
      <div class="items-center" *ngIf="projectProgrammeAttachments?.length > 0">
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[0.9rem] leading-normal"
        >
          Attachments

          <!-- Download attachment -->
          <div class="flex flex-col space-y-2 pl-[2rem]">
            <a
              *ngFor="let attachment of projectProgrammeAttachments"
              class="flex space-x-2"
              [ngClass]="{
                'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                  projectProgrammeAttachments,
                'text-black font-roboto text-[14px] font-normal leading-normal':
                  projectProgrammeAttachments
              }"
              #downloadTendererDocumentLink
              [href]="docUrl || '#'"
              (click)="
                downloadTendererDocument(
                  $event,
                  downloadTendererDocumentLink,
                  attachment?.id,
                  attachment?.path
                )
              "
            >
              <img
                [src]="getFileIcon(attachment)"
                alt="File Preview"
                class="object-cover w-5 h-5 cursor-pointer"
              />
              <span>{{ attachment?.name }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- CVs of Key Personnel-->
    <div class="my-[1rem]">
      <label>CVs of Key Personnel</label>
      <!-- Site Preparation Files-->
      <div
        class="items-center"
        *ngIf="cvsOfKeyPersonnelsAttachments?.length > 0"
      >
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[0.9rem] leading-normal"
        >
          Attachments

          <!-- Download attachment -->
          <div class="flex flex-col space-y-2 pl-[2rem]">
            <a
              *ngFor="let attachment of cvsOfKeyPersonnelsAttachments"
              class="flex space-x-2"
              [ngClass]="{
                'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                  cvsOfKeyPersonnelsAttachments,
                'text-black font-roboto text-[14px] font-normal leading-normal':
                  cvsOfKeyPersonnelsAttachments
              }"
              #downloadTendererDocumentLink
              [href]="docUrl || '#'"
              (click)="
                downloadTendererDocument(
                  $event,
                  downloadTendererDocumentLink,
                  attachment?.id,
                  attachment?.path
                )
              "
            >
              <img
                [src]="getFileIcon(attachment)"
                alt="File Preview"
                class="object-cover w-5 h-5 cursor-pointer"
              />
              <span>{{ attachment?.name }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Relevant Experience -->
    <div class="my-[1rem]">
      <h5 class="!pt-[3px]">Relevant Experience</h5>
      <label class="!pt-[3px] !font-medium !mb-[1rem]">
        Relevant Experience 1
      </label>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-x-4">
        <div>
          <label class="!text-[0.875rem]">Client Name </label>
          <p>{{ experience?.client_name_control1 }}</p>
        </div>
        <div>
          <label class="!text-[0.875rem]">Location</label>
          <p>{{ experience?.location_control1 }}</p>
        </div>
        <div>
          <label class="!text-[0.875rem]">Description</label>
          <p>{{ experience?.project_description_control1 }}</p>
        </div>
      </div>
      <label class="!pt-[3px] !font-medium !mb-[1rem]">
        Relevant Experience 2
      </label>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-x-4">
        <div>
          <label class="!text-[0.875rem]">Client Name </label>
          <p>{{ experience?.client_name_control2 }}</p>
        </div>
        <div>
          <label class="!text-[0.875rem]">Location</label>
          <p>{{ experience?.location_control2 }}</p>
        </div>
        <div>
          <label class="!text-[0.875rem]">Description</label>
          <p>{{ experience?.project_description_control2 }}</p>
        </div>
      </div>
      <label class="!pt-[3px] !font-medium !mb-[1rem]">
        Relevant Experience 3
      </label>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-x-4">
        <div>
          <label class="!text-[0.875rem]">Client Name </label>
          <p>{{ experience?.client_name_control3 }}</p>
        </div>
        <div>
          <label class="!text-[0.875rem]">Location</label>
          <p>{{ experience?.location_control3 }}</p>
        </div>
        <div>
          <label class="!text-[0.875rem]">Description</label>
          <p>{{ experience?.project_description_control3 }}</p>
        </div>
      </div>
      <div
        class="items-center"
        *ngIf="relevantExperienceAttachments?.length > 0"
      >
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[16px] leading-normal"
        >
          Attachments

          <!-- Download attachment -->
          <div class="flex flex-col space-y-2 pl-[2rem]">
            <a
              *ngFor="let attachment of relevantExperienceAttachments"
              class="flex space-x-2"
              [ngClass]="{
                'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                  relevantExperienceAttachments,
                'text-black font-roboto text-[14px] font-normal leading-normal':
                  relevantExperienceAttachments
              }"
              #downloadTendererDocumentLink
              [href]="docUrl || '#'"
              (click)="
                downloadTendererDocument(
                  $event,
                  downloadTendererDocumentLink,
                  attachment?.id,
                  attachment?.path
                )
              "
            >
              <img
                [src]="getFileIcon(attachment)"
                alt="File Preview"
                class="object-cover w-5 h-5 cursor-pointer"
              />
              <span>{{ attachment?.name }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- Health & Safety Management Plan. -->
    <div class="my-[1rem]">
      <label>Health & Safety Management Plan</label>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1">
        <div>
          <p
            class="text-justify"
            [innerHTML]="getSanitizedHtml(tendererResponse?.health_safety_plan)"
          ></p>
        </div>
      </div>
      <div
        class="items-center"
        *ngIf="technicalHealthSafetyAttachments?.length > 0"
      >
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[0.9rem] leading-normal"
        >
          Attachments

          <!-- Download attachment -->
          <div class="flex flex-col space-y-2 pl-[2rem]">
            <a
              *ngFor="let attachment of technicalHealthSafetyAttachments"
              class="flex space-x-2"
              [ngClass]="{
                'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                  technicalHealthSafetyAttachments,
                'text-black font-roboto text-[14px] font-normal leading-normal':
                  technicalHealthSafetyAttachments
              }"
              #downloadTendererDocumentLink
              [href]="docUrl || '#'"
              (click)="
                downloadTendererDocument(
                  $event,
                  downloadTendererDocumentLink,
                  attachment?.id,
                  attachment?.path
                )
              "
            >
              <img
                [src]="getFileIcon(attachment)"
                alt="File Preview"
                class="object-cover w-5 h-5 cursor-pointer"
              />
              <span>{{ attachment?.name }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Environmental Sustainability Plan -->
    <div class="my-[1rem]">
      <label> Environmental Sustainability Plan </label>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-x-4">
        <p>Do you have a Health and Safety Policy in place?</p>
        <mat-radio-group
          aria-label="Health and Safety Policy"
          class="flex gap-4"
          [disabled]="true"
          [value]="tendererResponse?.has_environmental_plan"
        >
          <mat-radio-button [value]="1">Yes</mat-radio-button>
          <mat-radio-button [value]="0">No</mat-radio-button>
        </mat-radio-group>
        <div *ngIf="tendererResponse?.has_environmental_plan === 1">
          <label class="!text-[0.875rem]">Description </label>
          <p>
            {{ tendererResponse?.environmental_plan_description }}
          </p>
        </div>
      </div>
      <div
        class="items-center"
        *ngIf="environmentalSustainabilityPlanAttachments?.length > 0"
      >
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[0.9rem] leading-normal"
        >
          Attachments

          <!-- Download attachment -->
          <div class="flex flex-col space-y-2 pl-[2rem]">
            <a
              *ngFor="let attachment of environmentalSustainabilityPlanAttachments"
              class="flex space-x-2"
              [ngClass]="{
                'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                environmentalSustainabilityPlanAttachments,
                'text-black font-roboto text-[14px] font-normal leading-normal':
                environmentalSustainabilityPlanAttachments
              }"
              #downloadTendererDocumentLink
              [href]="docUrl || '#'"
              (click)="
                downloadTendererDocument(
                  $event,
                  downloadTendererDocumentLink,
                  attachment?.id,
                  attachment?.path
                )
              "
            >
              <img
                [src]="getFileIcon(attachment)"
                alt="File Preview"
                class="object-cover w-5 h-5 cursor-pointer"
              />
              <span>{{ attachment?.name }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Technical Deviations/Clarifications -->
    <div class="my-[1rem]">
      <label> Technical Deviations/Clarifications </label>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-x-4">
        <p>Do you have technical deviations/clarifications?</p>
        <mat-radio-group
          aria-label="Health and Safety Policy"
          class="flex gap-4"
          [disabled]="true"
          [value]="tendererResponse?.has_technical_deviations"
        >
          <mat-radio-button [value]="1">Yes</mat-radio-button>
          <mat-radio-button [value]="0">No</mat-radio-button>
        </mat-radio-group>
        <div *ngIf="tendererResponse?.has_technical_deviations === 1">
          <label class="!text-[0.875rem]">Description </label>
          <p>
            {{ tendererResponse?.technical_deviations_description }}
          </p>
        </div>
      </div>
    </div>
    <div
        class="items-center"
        *ngIf="technicalDeviationsClarificationsAttachments?.length > 0"
      >
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[0.9rem] leading-normal"
        >
          Attachments

          <!-- Download attachment -->
          <div class="flex flex-col space-y-2 pl-[2rem]">
            <a
              *ngFor="let attachment of technicalDeviationsClarificationsAttachments"
              class="flex space-x-2"
              [ngClass]="{
                'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                technicalDeviationsClarificationsAttachments,
                'text-black font-roboto text-[14px] font-normal leading-normal':
                technicalDeviationsClarificationsAttachments
              }"
              #downloadTendererDocumentLink
              [href]="docUrl || '#'"
              (click)="
                downloadTendererDocument(
                  $event,
                  downloadTendererDocumentLink,
                  attachment?.id,
                  attachment?.path
                )
              "
            >
              <img
                [src]="getFileIcon(attachment)"
                alt="File Preview"
                class="object-cover w-5 h-5 cursor-pointer"
              />
              <span>{{ attachment?.name }}</span>
            </a>
          </div>
        </div>
      </div>
  </div>

  <!-- Commercial Submission -->
  <div class="!pl-[60px]">
    <h5>Commercial Submission</h5>
    <div class="mb-[1rem]">
      <label class="">Price Breakdown</label>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
        <div>
          <p
            class="text-justify"
            [innerHTML]="
              getSanitizedHtml(tendererResponse?.price_breakdown_description)
            "
          ></p>
        </div>
      </div>
      <div
        class="items-center"
        *ngIf="commercialPriceBreakdownAttachments?.length > 0"
      >
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[0.9rem] leading-normal"
        >
          Attachments

          <!-- Download attachment -->
          <div class="flex flex-col space-y-2 pl-[2rem]">
            <a
              *ngFor="let attachment of commercialPriceBreakdownAttachments"
              class="flex space-x-2"
              [ngClass]="{
                'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                  commercialPriceBreakdownAttachments,
                'text-black font-roboto text-[14px] font-normal leading-normal':
                  commercialPriceBreakdownAttachments
              }"
              #downloadTendererDocumentLink
              [href]="docUrl || '#'"
              (click)="
                downloadTendererDocument(
                  $event,
                  downloadTendererDocumentLink,
                  attachment?.id,
                  attachment?.path
                )
              "
            >
              <img
                [src]="getFileIcon(attachment)"
                alt="File Preview"
                class="object-cover w-5 h-5 cursor-pointer"
              />
              <span>{{ attachment?.name }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Financial Stability-->
    <div class="my-[1rem]">
      <label class="">Financial Stability</label>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
        <div>
          <p
            class="text-justify"
            [innerHTML]="
              getSanitizedHtml(
                tendererResponse?.financial_stability_description
              )
            "
          ></p>
        </div>
      </div>
      <div
        class="items-center"
        *ngIf="financialStabilityAttachments?.length > 0"
      >
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[0.9rem] leading-normal"
        >
          Attachments

          <!-- Download attachment -->
          <div class="flex flex-col space-y-2 pl-[2rem]">
            <a
              *ngFor="let attachment of financialStabilityAttachments"
              class="flex space-x-2"
              [ngClass]="{
                'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                  financialStabilityAttachments,
                'text-black font-roboto text-[14px] font-normal leading-normal':
                  financialStabilityAttachments
              }"
              #downloadTendererDocumentLink
              [href]="docUrl || '#'"
              (click)="
                downloadTendererDocument(
                  $event,
                  downloadTendererDocumentLink,
                  attachment?.id,
                  attachment?.path
                )
              "
            >
              <img
                [src]="getFileIcon(attachment)"
                alt="File Preview"
                class="object-cover w-5 h-5 cursor-pointer"
              />
              <span>{{ attachment?.name }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Contractual Comments -->
    <div class="my-[1rem]">
      <label class="">Contractual Comments</label>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
        <div>
          <p
            class="text-justify"
            [innerHTML]="
              getSanitizedHtml(tendererResponse?.contractual_comments)
            "
          ></p>
        </div>
      </div>
    </div>

    <!-- Proof of Insurance-->
    <div class="my-[1rem]">
      <label class="">Proof of Insurance</label>
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4">
        <div>
          <p
            class="text-justify"
            [innerHTML]="
              getSanitizedHtml(
                tendererResponse?.financial_stability_description
              )
            "
          ></p>
        </div>
      </div>
      <div class="items-center" *ngIf="proofOfInsuranceAttachments?.length > 0">
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[0.9rem] leading-normal"
        >
          Attachments

          <!-- Download attachment -->
          <div class="flex flex-col space-y-2 pl-[2rem]">
            <a
              *ngFor="let attachment of proofOfInsuranceAttachments"
              class="flex space-x-2"
              [ngClass]="{
                'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                  proofOfInsuranceAttachments,
                'text-black font-roboto text-[14px] font-normal leading-normal':
                  proofOfInsuranceAttachments
              }"
              #downloadTendererDocumentLink
              [href]="docUrl || '#'"
              (click)="
                downloadTendererDocument(
                  $event,
                  downloadTendererDocumentLink,
                  attachment?.id,
                  attachment?.path
                )
              "
            >
              <img
                [src]="getFileIcon(attachment)"
                alt="File Preview"
                class="object-cover w-5 h-5 cursor-pointer"
              />
              <span>{{ attachment?.name }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Performance Bond/Guarantee-->
    <div *ngIf="performanceBondsAttachments?.length > 0" class="my-[1rem]">
      <label class="">Performance Bond/Guarantee</label>
      <div class="items-center">
        <div
          class="text-[color:var(--Darkest-Grey,#21252A)] font-roboto text-[0.9rem] leading-normal"
        >
          Attachments

          <!-- Download attachment -->
          <div class="flex flex-col space-y-2 pl-[2rem]">
            <a
              *ngFor="let attachment of performanceBondsAttachments"
              class="flex space-x-2"
              [ngClass]="{
                'text-black font-roboto text-[14px] font-normal leading-normal cursor-pointer underline text-[rgb(0,0,255)]':
                  performanceBondsAttachments,
                'text-black font-roboto text-[14px] font-normal leading-normal':
                  performanceBondsAttachments
              }"
              #downloadTendererDocumentLink
              [href]="docUrl || '#'"
              (click)="
                downloadTendererDocument(
                  $event,
                  downloadTendererDocumentLink,
                  attachment?.id,
                  attachment?.path
                )
              "
            >
              <img
                [src]="getFileIcon(attachment)"
                alt="File Preview"
                class="object-cover w-5 h-5 cursor-pointer"
              />
              <span>{{ attachment?.name }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Conclusion -->
  <div class="!pl-[60px]">
    <h5>Conclusion</h5>
    <p>
      We welcome your participation in this tender process and look forward to
      receiving your proposal. Should you require any further information or
      Clarification (NEW SYSTEM REQUIRED), please do not hesitate to contact us
      as indicated in Section 4.
      <br />Yours sincerely,
    </p>
    <div class="!pl-[1rem]">
      <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-x-4">
        <div>
          <label>Name </label>
          <p>{{ tendererResponse?.tenderer_name }}</p>
        </div>
        <div>
          <label>Position </label>
          <p>{{ tendererResponse?.tenderer_position }}</p>
        </div>
        <div>
          <label>Company Name </label>
          <p>{{ tendererResponse?.tenderer_company_name }}</p>
        </div>
        <div>
          <label>Contact Information </label>
          <p>{{ tendererResponse?.tenderer_contact_information }}</p>
        </div>
      </div>
    </div>
  </div>
  <!-- Disclaimer -->
  <div>
    <div
      class="h-[55px] flex justify-start items-center mt-[60px] pl-[60px] mb-[18px] bg-[#F3F3F3]"
    >
      <h5 class="!m-0">Disclaimer</h5>
    </div>
    <div class="pl-[60px]">
      <p class="text-justify">The Client reserves the right to:</p>
      <ul class="text-justify !pl-10">
        <li>Amend or withdraw this RFP at any stage without liability.</li>
        <li>Reject any or all tenders without giving reasons.</li>
        <li>
          Award the contract in part or not at all, depending on the Clients
          best interests.
        </li>
        <li>
          Disqualify any tenderer found to have engaged in corrupt or fraudulent
          practices.
        </li>
      </ul>
    </div>
  </div>
</div>
